import { Injectable } from '@angular/core';
import { ApiResponse, ToastType } from '@shared/model';
import { TranslateService } from '@ngx-translate/core';
import Swal, { SweetAlertIcon, SweetAlertPosition } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  constructor(private tr: TranslateService) {}

  display({
    type,
    body,
    title,
    position,
    delay,
    toast,
    after,
  }: {
    type: ToastType;
    body: string;
    title?: string;
    position?: SweetAlertPosition;
    delay?: number;
    toast?: boolean;
    after?: () => void;
  }) {
    const iconMap: Record<ToastType, SweetAlertIcon> = {
      [ToastType.SUCCESS]: 'success',
      [ToastType.ERROR]: 'error',
      [ToastType.INFO]: 'info',
      [ToastType.WARNING]: 'warning',
    };

    const icon = iconMap[type] || 'warning';

    Swal.fire({
      text: this.tr.instant(body),
      icon: icon,
      showCloseButton: true,
      timer: delay || 3000,
      showConfirmButton: false,
      title: title || undefined,
      position: position || 'center',
      toast: toast,
    }).then(() => {
      if (after) {
        after();
      }
    });
  }

  showFromApiResponse(response: ApiResponse): void {
    if (!response.result) {
      this.display({
        type: ToastType.ERROR,
        body: response.code ? response.code! : 'toast.error',
        position: 'top-right',
        toast: true,
      });
    } else if (!response.code?.includes('list')) {
      this.display({
        type: ToastType.SUCCESS,
        body: response.code!,
        position: 'top-right',
        toast: true,
      });
    }
  }
}
